module.exports = __webpack_public_path__ + "static/media/haachim.1ec96252.webp";